export const HIERARCHY_PATH_DEFAULT_MESSAGE =
    'Category/Sub-Category to which it belongs does not exist, please restore it to another Category/Sub-category';

export const getArchiveColDefs = (
    handleExpansionToggleCallback: (data: any) => void,
    handleDetailsClickCallback: (data: any) => void,
    handleActionCallback: (action: string, data: any) => void,
    isRestoreActionDisabled: boolean,
    isDeleteActionDisabled: boolean
) => [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 450,
        resizable: true,
        cellRenderer: 'nameCellRenderer',
        cellRendererParams: {
            onExpansionToggle: handleExpansionToggleCallback
        },
        cellClass: 'name-cell-custom',
        headerClass: 'name-header-custom'
    },
    {
        field: 'order',
        headerName: 'Order',
        resizable: true,
        cellRenderer: 'orderCellRenderer'
    },
    {
        field: 'details',
        headerName: 'Details',
        resizable: true,
        cellRenderer: 'detailsCellRenderer',
        cellRendererParams: {
            handleDetailsClick: handleDetailsClickCallback
        }
    },
    {
        field: 'actions',
        headerName: '',
        minWidth: 150,
        resizable: true,
        cellRenderer: 'archiveCellRenderer',
        cellRendererParams: {
            onAction: handleActionCallback,
            isRestoreActionDisabled: isRestoreActionDisabled,
            isDeleteActionDisabled: isDeleteActionDisabled
        }
    }
];
